import { render, staticRenderFns } from "./TableMainTitle.vue?vue&type=template&id=551d79f6&scoped=true"
import script from "./TableMainTitle.vue?vue&type=script&lang=js"
export * from "./TableMainTitle.vue?vue&type=script&lang=js"
import style0 from "./TableMainTitle.vue?vue&type=style&index=0&id=551d79f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551d79f6",
  null
  
)

export default component.exports